import React from 'react';
import {connect} from 'react-redux';
import Stream from './Stream';
import SelectCamera from './SelectCamera';
import { moveCamerasInView } from '../../actions';

const VideoContainer = props => {

  const baseUrl = process.env.REACT_APP_WS_URL;
  const sDeviceID = props.camera && props.camera.sDeviceID ? props.camera.sDeviceID : '';
  const camNum = props.camera&& props.camera.bCamera ? props.camera.bCamera : 0;
  const profile = props.single ? '1' : '2';
  const sWSUrl = `${baseUrl}${sDeviceID}-cam${camNum}-pro${profile}`;
  const targetDevice = props.camera && props.camera.sDeviceID ? props.devices.find(device => device.sDeviceID === props.camera.sDeviceID) : null;
  const deviceOnline = targetDevice && targetDevice.fOnline === 1 ? 1 : 0;

  const onDragOver = (e) => {
    e.preventDefault()
  }

  const onDrop = (e) => {
    const cameraId = e.dataTransfer.getData('cameraId')
    props.moveCamerasInView(props.compositeCams, props.slotId, cameraId)
  }

  return (
    <div style={styles.container} onDrop={onDrop} onDragOver={onDragOver}>
      {props.camera && props.camera.sDeviceID
        ? <Stream
            key={sWSUrl}
            sWSUrl={sWSUrl}
            single={props.single}
            camera={props.camera}
            deviceOnline={deviceOnline}
            size={props.size} />
        : props.user.bRole !== 3 ? <SelectCamera slotId={props.slotId} /> : null
      }
    </div>
  )
}

const mapStateToProps = state => {
  const { devices, compositeCams } = state.data;
  const { user } = state.auth;
  return { devices, compositeCams, user }
}

export default connect(mapStateToProps, {moveCamerasInView})(VideoContainer);

const styles = {
  container: {
    width: '100%',
    height: '100%',
  },
}